import React, {useEffect, useState} from "react";
import {boldTextStyles, regularTextStyles} from "../Style";
import {DownloadIcon} from "./common/CarCommonComponents";
import Cookies from "js-cookie";
import {Spinner} from "react-bootstrap";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const PaymentSuccess = props => {
  const [pageRefreshed, setPageRefreshed] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  // let url = 'http://localhost:8080/edge';
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [verificationFailedStep, setVerificationFailedStep] = useState('');
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
      ? 'carAutosureEvent'
      : window.location.href.includes('quashed')
          ? 'carQuashedEvent'
          : window.location.href.includes('better')
              ? 'carBetterEvent'
              : window.location.href.includes('simplify')
                  ? 'carSimplifyEvent'
                  : '';

  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Submit',
        'categoryDetails': 'Payment Transfer Details',
        'status': 'Success',
        'virtualUrl': `${baseUrl}/vehicle/step5`,
        'pageTitle': 'Payment',
      });
  }, []);
  useEffect(() => {
    if (verificationFailedStep === "downloadPolicyDetails") {
      downloadPolicyDetails();
    }
  }, [verificationFailedStep]);
  const handleNewQuoteClick = () => {
    const href = window.location.href.toLowerCase();
    let campaign = 'autosure';
    if (href.includes('quashed')) {
      campaign = 'quashed';
    } else if (href.includes('better')) {
      campaign = 'better';
    }else if(href.includes('loanplace')){
      campaign = 'loanplace';
    } else if (href.includes('simplify')) {
      campaign = 'simplify';
    }
    window.location.href = `/vehicle?utm_medium=last&utm_source=concar&utm_campaign=${campaign}&utm_content=t`;
  };
  const handleMBIQuoteClick = () => {
    const href = window.location.href.toLowerCase();
    // Detect environment
    let env = 'prod'; // default
    if (href.includes('dev') || href.includes('localhost')) env = 'dev';
    else if (href.includes('uat')) env = 'uat';
    else if (href.includes('int')) env = 'int';
    else if (href.includes('pre')) env = 'pre';
    // Build base URL
    const domain = env === 'prod' ? 'online.autosure.co.nz' : `online.${env}.autosure.co.nz`;
    let campaign = 'autosure';
    if (href.includes('quashed')) {
      campaign = 'quashed';
    }
    window.location.href = `https://${domain}/autosure/mbi?utm_medium=last&utm_source=concar&utm_campaign=${campaign}&utm_content=t`;
  };
  const downloadPolicyDetails = async () => {
    setIsDownloading(true); // Show downloading icon
    let jwt = Cookies.get('jwt-token');
    let id = props.inputValues.id;
    if (!id) {
      const urlParams = new URLSearchParams(window.location.search);
      id = urlParams.get('id');
    }
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit')
    if (verificationFailedStep === "downloadPolicyDetails") {
      token = "AUTHENTICATED_V2"
    }
    fetch(url + '/vero/document/retrieve', {
      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": 'By-Pass-Auth-Create-Prospect'
      }),
      body: JSON.stringify({
        "documentType": "New Business",
        "policyNumber": props.inputValues.policyNumber,
        "recaptchaResponse": token,
        "uuid": id
      })
    })
      .then(response => {
        if (response.status === 428) {
          console.log('Primary reCAPTCHA failed for vehicle lookup, showing fallback captcha');
          setVerificationFailedStep("downloadPolicyDetails");
          return;
        }
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'policyDetails.pdf';  // The desired file name
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        setIsDownloading(false); // Hide downloading icon
      })
      .catch(error => {
        console.log('Error:', error);
        setIsDownloading(false); // Hide downloading icon in case of error
      });
  }
  return (
    <>
      <br/><br/>
      <div className="lg-car-padding  sm-car-padding">
        <div style={{paddingTop: "20px"}}>
          <p style={boldTextStyles}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                 className="bi bi-check-circle" viewBox="0 0 16 16" style={{color: "green"}}>
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path
                d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
            </svg>
            &nbsp;&nbsp;&nbsp;&nbsp;We are pleased to confirm that your payment has been successful.
          </p>
        </div>
        <div style={{paddingTop: "10px"}}>
          <p style={regularTextStyles}>Congratulations on taking out Autosure Car Insurance. </p>
        </div>
        <div style={{paddingTop: "34px"}}>
          <p style={boldTextStyles}>Your premium details are:</p>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            // boxShadow: '-1px 1px 5px 6px rgba(0,0,0,0.06)',
            border: '1px solid #D1D5DB',
          }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "50px"
          }}>
            <div
              id="policyNumberTitle"
              style={{
                background: 'white',
                textAlign: "start", paddingLeft: "24px", width: "100%",
                color: '#6B7280',
              }}
            >Payment Frequency
            </div>
            <div id="policyNumberVal"
                 style={{
                   color: "black",
                   textAlign: "start",
                   paddingLeft: "24px",
                   width: "100%"
                 }}
            ><span style={boldTextStyles}
            >{props.inputValues.paymentFrequency}</span>
            </div>
          </div>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "50px"
          }}>
            <div
              id="policyNumberTitle"
              style={{
                background: 'white',
                textAlign: "start", paddingLeft: "24px", width: "100%",
                color: '#6B7280',
              }}
            >Policy Number
            </div>
            <div id="policyNumberVal"
                 style={{
                   color: "black",
                   textAlign: "start",
                   paddingLeft: "24px",
                   width: "100%"
                 }}
            ><span style={boldTextStyles}
            >{props.inputValues.policyNumber}</span>
            </div>
          </div>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "50px"
          }}>
            <div
              id="policyNumberTitle"
              style={{
                background: 'white',
                textAlign: "start", paddingLeft: "24px", width: "100%",
                color: '#6B7280',
              }}
            >Policy Type
            </div>
            <div id="policyNumberVal"
                 style={{
                   color: "black",
                   textAlign: "start",
                   paddingLeft: "24px",
                   width: "100%"
                 }}
            ><span style={boldTextStyles}>
                                     {props.inputValues.insuranceCover === 'COMPREHENSIVE' && 'Everyday Plus'}
              {props.inputValues.insuranceCover === 'THIRD_PARTY_FIRE_THEFT' && 'Third Party, Fire & Theft'}
              {props.inputValues.insuranceCover === 'THIRD_PARTY' && 'Third Party Property Damage'}
                                </span>
            </div>
          </div>
          {props.inputValues.insuranceCover !== 'THIRD_PARTY' && <>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "50px"
          }}>
            <div
              id="policyNumberTitle"
              style={{
                background: 'white',
                textAlign: "start", paddingLeft: "24px", width: "100%",
                color: '#6B7280',
              }}
            >Amount Covered
            </div>
            <div id="policyNumberVal"
                 style={{
                   color: "black",
                   textAlign: "start",
                   paddingLeft: "24px",
                   width: "100%"
                 }}
            ><span style={boldTextStyles}
            > ${new Intl.NumberFormat().format(props.inputValues.vehicleValue)}</span>
            </div>
          </div>
          </>}
        </div>
        <div style={{paddingTop: "20px", paddingBottom: "50px"}}><DownloadIcon/>
          <span style={{
            color: '#1851A3', textDecoration: "underline",
            cursor: "pointer",
          }}
                onClick={downloadPolicyDetails}>
                                  Download policy details
                          </span>
          {isDownloading && <Spinner/>}
        </div>

        <div style={{paddingTop: "20px", paddingBottom: "50px"}}>
          <div style={regularTextStyles}>
            <p>Your insurance documents will be emailed to you. Please have a good read through the
              documents and if anything on your policy schedule is incorrect or wrong please call
              us on <span className='spanLink'
                          style={{color: "#0D6EFD"}}
                          onClick={() => {
                            window.location = "tel:0800262411"
                          }}><u>0800 262 411 </u></span>
              and let us know straight away. This is important as incorrect
              information could mean that you don't have any cover.
            </p>

            <p>This email will come from <a
              href="mailto:noreply@vero.co.nz">noreply@vero.co.nz</a> as Vero Insurance NZ Limited
              is the underwriter of your policy and ‘Vero Insurance NZ Limited’ will appear as the
              payee on your bank statement.</p>

            <p>You can cancel your policy within 21 days of the start of your cover, provided you
              have not made a claim and we will refund you any premiums you have paid.</p>

            <p> If you have any questions please contact us on <span className='spanLink'
                                                                     style={{color: "#0D6EFD"}}
                                                                     onClick={() => {
                                                                       window.location = "tel:0800262411"
                                                                     }}><u>0800 262 411</u></span>
            </p>

            <p>With this protection in place, we hope you enjoy many years of peace of mind driving
              ahead.</p>
          </div>
        </div>
        <div style={{paddingBottom: "150px"}}>
          <div style={regularTextStyles}>
            <p>
              What would you like to do next?
            </p>
            <p>
              <ul>
                <li>
                                    <span style={{
                                      color: '#1851A3', textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                          onClick={handleNewQuoteClick}>
                                    Look at car insurance for another car
                                    </span>
                </li>
                {!window.location.hostname.toLowerCase().split('.').includes('better') &&
                  !window.location.hostname.toLowerCase().split('.').includes('loanplace') &&
                  !window.location.hostname.toLowerCase().split('.').includes('simplify') && <>
                <li>
                                      <span style={{
                                        color: '#1851A3', textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                            onClick={handleMBIQuoteClick}>
                                          Look at mechanical breakdown insurance
                                      </span>
                </li>
                </>}
                <li>Nothing, I'm all sorted thanks</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default PaymentSuccess;
